export default __webpack_public_path__ + "static/media/srg-dark.9ace2de4.svg";